<form class="modal-body wrapper-modal py-4 mx-2 mx-md-4 position-relative row" [formGroup]="form" (submit)="onSubmit()">
    <i matTooltip="Cerrar" class="fa-solid fa-xmark fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <h3 class="text-bold text-center col-12 px-3 mb-3">
        {{paramsDialog?.type==='license'? 'Licencia del conductor' : 'Datos del vehículo'}}
    </h3>

    <!--Basic fields-->
    <div *ngIf="paramsDialog?.type==='vehicle'" class="d-flex flex-wrap">
        <app-type-vehicle class="col-lg-4 col-md-6 h-auto" [options]="optionsVehicleType"
            [inputFormControl]="vehicleTypeControl" [validate]="vehicleValidate">
        </app-type-vehicle>
        <app-vehicle-body-work-type class="col-lg-4 col-md-6" [inputFormControl]="bodyworkTypeControl"
            [validate]="bodyworkValidate" [options]="optionsBodyworkType"></app-vehicle-body-work-type>

        <!-- Registration date vehicle -->
        <mat-form-field appearance="outline" class="col-lg-4 col-md-6">
            <mat-label>Fecha de matriculación</mat-label>
            <input matInput [matDatepickerFilter]="registrationDateFilter" [matDatepicker]="pickerRegistrationDate"
                [formControl]="form.get('registrationDate')" readonly (click)="pickerRegistrationDate.open()"
                class="cursor-pointer">
            <mat-datepicker-toggle matSuffix [for]="pickerRegistrationDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerRegistrationDate></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-4 col-md-6"
            [ngClass]="{'d-none': !isVisibleField(field.key)}"
            *ngFor="let field of global?.vehicleEditableFieldsAlias | keyvalue:originalOrder">
            <mat-label>{{field.value}}</mat-label>
            <input matInput type="text" [formControl]="form?.get(field.key)">
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-4 col-md-6" id="serviceTypeStep">
            <mat-label>Tipo de servicio</mat-label>
            <mat-select formControlName="serviceType">
                <mat-option *ngFor="let serviceType of serviceTypes" [value]="serviceType">
                    {{serviceType}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>


    <!--Valid RTM-->
    <div *ngIf="paramsDialog?.type==='RTM'" class="d-flex flex-wrap w-100">
        <label class="col-12 text-bold">RTM</label>
        <mat-form-field appearance="outline" class="col-12">
            <mat-label>Fecha de expiración</mat-label>
            <input matInput [matDatepicker]="pickerRTMexpiration" [formControl]="form.get('validRTM.expirationDate')"
                readonly (click)="pickerRTMexpiration.open()">
            <mat-datepicker-toggle matSuffix [for]="pickerRTMexpiration"></mat-datepicker-toggle>
            <mat-datepicker #pickerRTMexpiration></mat-datepicker>
        </mat-form-field>
    </div>


    <!--Valid SOAT-->
    <div *ngIf="paramsDialog?.type==='SOAT'" class="d-flex flex-wrap">
        <label class="col-12 text-bold">SOAT</label>
        <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Fecha de expiración</mat-label>
            <input matInput [matDatepicker]="pickerSOATexpiration" [formControl]="form.get('validSOAT.expirationDate')"
                readonly (click)="pickerSOATexpiration.open()">
            <mat-datepicker-toggle matSuffix [for]="pickerSOATexpiration"></mat-datepicker-toggle>
            <mat-datepicker #pickerSOATexpiration></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Compañía de seguros</mat-label>
            <input matInput type="text" [formControl]="form?.get('validSOAT.companyName')">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Número de la compañía</mat-label>
            <input matInput type="text" [formControl]="form?.get('validSOAT.companyNumber')">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Número del seguro</mat-label>
            <input matInput type="text" [formControl]="form?.get('validSOAT.number')">
        </mat-form-field>
    </div>

    <!--License-->

    <ng-container *ngIf="paramsDialog?.type==='license'">
        <app-license-form class="d-flex flex-wrap" [form]="form"></app-license-form>
    </ng-container>

    <div class="col-md-12 button-container">
        <button mat-raised-button color="primary" type="button" class="primary-secondary" (click)="dialogRef.close()">
            Cancelar
        </button>
        <button mat-raised-button color="primary" type="submit" class="bg-color-primary">
            Guardar
        </button>
    </div>
</form>